import snakeCase from 'lodash-es/snakeCase';
import camelCase from 'lodash-es/camelCase';
import { deepMapKeys } from './deepMapKeys';

const convertKey = (key: string, convert: (key: string) => string) => {
  // Next keys shouldn't be encoded:
  // - uuid key contains `-`
  // - translations contains `.`
  return key.includes('-') || key.includes('.') ? key : convert(key);
};

const camelizeKey = (key: string) => convertKey(key, camelCase);

const decamelizeKey = (key: string) => convertKey(key, snakeCase);

export const camelize = <T extends Record<string, unknown>>(
  data: Record<string, unknown>
) => deepMapKeys(data, camelizeKey) as T;

export const decamelize = <T extends Record<string, unknown>>(
  data: Record<string, unknown>
) => deepMapKeys(data, decamelizeKey) as T;
